import React from 'react';
import { Button, Center, Image, Stack, Text, Title } from '@mantine/core';

const ErrorDisplay: React.FC = () => (
  <Center h="100dvh" w="100dvw">
    <Stack align="center" gap="md">
      <Image w="15rem" src="/assets/images/request_error@3x.png" />
      <Title ta="center">Oops.</Title>
      <Text ta="center" size="sm">Something went wrong on our end.<br /> Refresh the page or check back later.</Text>
      <Button variant="outline" onClick={() => window.location.reload()}>
        Click to refresh the page
      </Button>
    </Stack>
  </Center>
);

export default ErrorDisplay;
